module.exports = __webpack_public_path__ + "img/subheader01.cfc08e0b.jpg";